import type { Types } from '../types';
import type { OutTypes } from './schedules';
import { getVertexId } from '../util';
import { omitEdgesAndInternalProperties, type SerializedEdgesOnlyVertexExport, type SerializedEdgesShape } from './util';
import type { BaseOptions } from '../../common/types';
import type { PersonVertex } from '../interfaces/vertices/persons';

export default (
  persons: Types.Mixed.Person[],
  options: BaseOptions
): OutTypes.person[] => {
  return persons
    .map(x => {
      const edges: SerializedEdgesOnlyVertexExport<PersonVertex> = {
        group: x.group ? getVertexId(x.group, options) : undefined,
      } satisfies SerializedEdgesShape<SerializedEdgesOnlyVertexExport<PersonVertex>>;
      const nonEdges = omitEdgesAndInternalProperties(x, edges);

      return { ...nonEdges, ...edges };
    });
};
